<div class="mt-3">
  <p-panel header="Finished goods" [toggleable]="true">
    <div>
      <div class="align-items-center d-flex col-lg-12 mb-3">
        <div class="nav-link p-0 d-flex align-items-center">
          <a class="link" (click)="addNewService()"
            ><i class="pi pi-plus"></i> Add Line</a
          >
        </div>

        <div class="ms-3 nav-link p-0 d-flex align-items-center delete">
          <div>
            <i class="icon-Delete me-2"></i>
            <a class="link" (click)="onRowDelete()"
              ><i class="pi pi-trash"></i> Remove</a
            >
          </div>
        </div>
        <div class="ms-3 nav-link p-0 d-flex align-items-center delete">
          <div>
            <i class="icon-Copy me-2"></i>
            <a class="link" (click)="onCopyLines()"
              ><i class="pi pi-copy"></i> Copy Lines</a
            >
          </div>
        </div>
      </div>

      <p-table
        #dt
        stripedRows
        [rowHover]="true"
        [showCurrentPageReport]="true"
        [scrollable]="true"
        scrollHeight="350px"
        [size]="'small'"
        [resizableColumns]="true"
        [value]="filteredFinishedGoodsList"
        [(selection)]="selectedGoods"
        styleClass="p-datatable-customers ordersLineItems no-wrap table-hover-bg cstm-table-hover no-overfollow"
        [rowHover]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10, 25, 50]"
        [paginator]="false"
        [filterDelay]="0"
        dataKey="portalKeyD365"
        editMode="row"
        selectionMode="multiple"
        [scrollable]="true"
        styleClass="table-listing">
        <ng-template pTemplate="header">
          <tr class="table-head">
            <!-- <th style="width: 3rem"></th> -->
            <th></th>
            <th class="col-center">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th class="vendor-sku">SKU</th>
            <!-- <th class="description colwdth-large">Description</th> -->
            <!-- <th class="description">Product Name</th> -->
            <!-- <th class="quantity">Configuration</th> -->
            <th class="net">Color</th>
            <th class="net">Style / Fit</th>
            <!-- <th class="sell-total">Color</th> -->
            <!-- <th class="net">Style</th> -->
            <th class="sell">Size</th>
            <!-- <th class="net">Physical Inventory</th>
            <th class="net">Available Physical</th> -->
            <th class="net">Quantity</th>
            <!-- <th class="net">Unit</th> -->
            <th class="net">Net</th>
            <th class="net">Net Total</th>
          </tr>
        </ng-template>
        <ng-template
          pTemplate="body"
          let-finishedGoods
          let-editing="editing"
          let-ri="rowIndex"
          let-rowIndex="rowIndex">
          <ng-container>
            <tr
              [pReorderableRow]="rowIndex"
              class="p-selectable-row"
              [pEditableRow]="finishedGoods"
              [pSelectableRow]="finishedGoods">
              <!-- <td>
                  <span
                    class="pi pi-bars"
                    [pReorderableRowHandle]="rowIndex"
                  ></span>
                </td> -->
              <td style="text-align: center">
                <button
                  *ngIf="!editing"
                  pButton
                  pRipple
                  type="button"
                  pInitEditableRow
                  icon="pi pi-pencil"
                  class="p-button-rounded p-button-text"
                  (click)="
                    onEditRow(finishedGoods.portalKeyD365, finishedGoods)
                  "></button>
                <button
                  *ngIf="editing"
                  pButton
                  pRipple
                  type="button"
                  pSaveEditableRow
                  icon="pi pi-check"
                  class="p-button-rounded p-button-text p-button-success p-mr-2 selectable-color selectable-color"
                  (click)="onRowEditSave(finishedGoods)"></button>
                <button
                  *ngIf="editing"
                  pButton
                  pRipple
                  type="button"
                  pCancelEditableRow
                  icon="pi pi-times"
                  class="p-button-rounded p-button-text p-button-danger"
                  (click)="refreshGrid()"></button>
              </td>
              <td class="col-center">
                <p-tableCheckbox
                  [pSelectableRow]="finishedGoods"
                  [value]="finishedGoods"></p-tableCheckbox>
              </td>
              <td pEditableColumn pEditableColumnField="itemNumberD365">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-select
                      id="currency"
                      [editable]="editing ? false : true"
                      [(ngModel)]="finishedGoods.itemNumberD365"
                      (onChange)="itemSelected($event, finishedGoods)"
                      appendTo="body"
                      [options]="[itemNumber]"
                      [filter]="true"
                      [showClear]="true">
                    </p-select>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ finishedGoods?.itemNumberD365 }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <!-- <td
                class="description colwdth-large"
                [ngClass]="{
                  'trimmeddescription trimmedby50char': descriptionCharacterCond
                }"
              >
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <textarea
                      style="height: auto; max-height: 150px; width: 100%"
                      jniAutoCompleteBlocker
                      pInputText
                      type="text"
                      [(ngModel)]="finishedGoods.lineDescriptionD365"
                      required
                    ></textarea>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{
                      descriptionCharacterCount(finishedGoods.lineDescriptionD365)
                    }}
                    {{ finishedGoods.lineDescriptionD365 }}
                  </ng-template>
                </p-cellEditor>
              </td> -->
              <!-- <td class="description">
                  {{ finishedGoods.productNameD365 }}
                </td> -->
              <!-- <td class="sell">
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <ng-select
                        
                        id="currency"
                        style="width: auto"
                        [(ngModel)]="finishedGoods.configD365"
                        appendTo=".finished-good"
                      >
                        <ng-option *ngFor="let com of filteredConfig" [value]="com">
                          {{ com }}
                        </ng-option>
                      </ng-select>
                    </ng-template>
                    <ng-template pTemplate="output">
                      {{ finishedGoods.configD365 }}
                    </ng-template>
                  </p-cellEditor>
                </td> -->
              <!-- <td class="net">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <ng-select
                      
                      id="currency"
                      style="width: auto"
                      [(ngModel)]="finishedGoods.colorD365"
                      (clear)="generateDescription(finishedGoods)"
                      (change)="generateDescription(finishedGoods)"
                      appendTo=".finished-good"
                    >
                      <ng-option *ngFor="let com of filteredColors" [value]="com">
                        {{ com }}
                      </ng-option>
                    </ng-select>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ finishedGoods.colorD365 }}
                  </ng-template>
                </p-cellEditor>
              </td> -->
              <td
                class="net"
                pEditableColumn
                pEditableColumnField="colorD365"
                (click)="
                  setSizeAndColor(finishedGoods.itemNumberD365, finishedGoods)
                ">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-select
                      id="currency"
                      [editable]="editing ? false : true"
                      [(ngModel)]="finishedGoods.colorD365"
                      (onClear)="generateDescription(finishedGoods)"
                      (onChange)="generateDescription(finishedGoods)"
                      appendTo="body"
                      [options]="filteredColors"
                      [filter]="true"
                      [showClear]="true">
                    </p-select>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ finishedGoods.colorD365 }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td
                class="net"
                pEditableColumn
                pEditableColumnField="styleD365"
                (click)="
                  setSizeAndColor(finishedGoods.itemNumberD365, finishedGoods)
                ">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-select
                      [editable]="editing ? false : true"
                      id="currency"
                      [(ngModel)]="finishedGoods.styleD365"
                      (onClear)="generateDescription(finishedGoods)"
                      (onChange)="generateDescription(finishedGoods)"
                      appendTo="body"
                      [options]="filteredStyles"
                      [filter]="true"
                      [showClear]="true">
                    </p-select>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ finishedGoods.styleD365 }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td
                class="sell"
                pEditableColumn
                pEditableColumnField="sizeD365"
                (click)="
                  setSizeAndColor(finishedGoods.itemNumberD365, finishedGoods)
                ">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-select
                      id="currency"
                      [editable]="editing ? false : true"
                      [(ngModel)]="finishedGoods.sizeD365"
                      (onClear)="generateDescription(finishedGoods)"
                      (onChange)="generateDescription(finishedGoods)"
                      appendTo="body"
                      [options]="filteredSizes"
                      [filter]="true"
                      [showClear]="true">
                    </p-select>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ finishedGoods.sizeD365 }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <!-- <td class="net">
                {{ finishedGoods.physicalInventoryD365 }}
              </td>
              <td class="net">
                {{ finishedGoods.physicalAvailableD365 }}
              </td> -->
              <td
                class="quantity"
                pEditableColumn
                pEditableColumnField="orderedPurchaseQuantityD365">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input
                      jniAutoCompleteBlocker
                      pInputText
                      type="text"
                      [(ngModel)]="finishedGoods.orderedPurchaseQuantityD365"
                      (keydown)="onQuantityKeyDown($event, finishedGoods)"
                      (change)="
                        calculateQuantity(
                          finishedGoods.orderedPurchaseQuantityD365,
                          finishedGoods
                        )
                      "
                      (focus)="selectText($event)"
                      required />
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ finishedGoods.orderedPurchaseQuantityD365 }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <!-- <td class="net">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <ng-select
                      
                      id="currency"
                      style="width: auto"
                      [(ngModel)]="finishedGoods.purchaseUnitSymbolD365"
                      appendTo=".finished-good"
                    >
                      <ng-option *ngFor="let com of unit" [value]="com">
                        {{ com }}
                      </ng-option>
                    </ng-select>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ finishedGoods.purchaseUnitSymbolD365 }}
                  </ng-template>
                </p-cellEditor>
              </td> -->

              <td class="quantity">
                {{
                  finishedGoods.purchasePriceD365
                    | currency
                      : getCurrencyConvertionCode(
                          finishedGoods?.currencyCodeD365 || ""
                        )
                      : "symbol"
                      : "0.4-4"
                }}
              </td>
              <td class="ntotal">
                {{
                  finishedGoods.lineAmountD365
                    | currency
                      : getCurrencyConvertionCode(
                          finishedGoods?.currencyCodeD365 || ""
                        )
                      : "symbol"
                      : "0.2-2"
                }}
              </td>
            </tr>
          </ng-container>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="20" class="colwdth-large nofound">
              No line item found.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </p-panel>
</div>
